function bookmarkMatchesThumb(bookmark, thumb) {
  return bookmark.page === thumb.label;
}

export function findBookmarkForThumb(bookmarks, thumb) {
  return bookmarks.filter(b => bookmarkMatchesThumb(b, thumb))[0];
}



// WEBPACK FOOTER //
// ./src/app/api/redux-jigsaw/userdata/bookmarks/utils.js